const AppConfig = {
  LANGUAGES: ['pl', 'en', 'de'], // Language order matters in fallbacks
  TRANSLATIONS: ['pl'], // Available .json translation files, order matters in fallbacks
  DEFAULT_LANG: 'pl',
};

export default AppConfig;
